import React, { useEffect, useState } from 'react';
import { Container, Card, Form, Table, InputGroup, Button, ButtonGroup, Col, Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { getEmployeesChronically, updateSearch, postsearchText, getEmployeesProbation, resetList, dismissEmployee, postsearchTextProbation } from "../../3.Store/EmployeeSlice";
import { ThreeDots } from 'react-loader-spinner';
import moment from "moment/moment";
import { ServiceLength } from "../../2.Commons/DropdownOption";
import Swal from "sweetalert2";
import Pagination from '../../2.Commons/Pagination';

const EmployeeProbationList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [table, setTable] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const employeeLists = useSelector(state => state.EmployeeSlice.employees);
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 20; // Number of items per page
    const totalPages = Math.ceil(employeeLists.length / pageSize);

    const employeeListsProbation = useSelector(state => state.EmployeeSlice.employees_probation);
    const [currentPage1, setCurrentPage1] = useState(1);
    const totalPages1 = Math.ceil(employeeListsProbation.length / pageSize);

    const getSearchParamsFromQuery = () => {
        const params = new URLSearchParams(location.search);
        const searchText = params.get('searchText') || '';
        const active = params.get('active') || '1';
        return { searchText, active };
    };

    const { searchText: initialSearchText, active: initialActive } = getSearchParamsFromQuery();

    const [searchText, setSearchText] = useState(initialSearchText);
    const [active, setActive] = useState(parseInt(initialActive, 10));

    const role = JSON.parse(localStorage.getItem("roles"));
    
    useEffect(() => {

        if (!role || !role.includes("HR-EMP-PRO-MGT")) {  // Check required role 
            localStorage.clear(); 
            window.location.href = "/Login"; 
        }

        const search = {
            searchText: initialSearchText,
            active: parseInt(initialActive, 10),
        };
        dispatch(updateSearch(search));
        setSearchText(initialSearchText);
        setActive(parseInt(initialActive, 10));
        if (initialSearchText || initialActive !== '0') {
            handleBtnSearch(searchText, active);
        }
    }, [initialSearchText, initialActive]);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleSearch = (e) => {
        setSearchText(e.target.value);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleBtnSearch();
        }
    };

    const handleBtnSearch = (searchTextOverride = searchText, activeOverride = active) => {
        setTable(true);
        setLoading(true);
        setCurrentPage(1);
        setCurrentPage1(1);
        dispatch(resetList());
        const entity = { searchText: searchTextOverride, active: activeOverride };
        dispatch(updateSearch(entity));
        if (searchTextOverride === "") {
          dispatch(getEmployeesProbation())
            // .then(() => dispatch(getEmployeesProbation()))
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
        } else {
          dispatch(postsearchTextProbation(entity))
            // .then(() => dispatch(postsearchTextProbation(entity)))
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
        }
    };

    const handleClickView = (id) => {
        navigate(`/EmployeeForm/${id}?searchText=${searchText}&active=${active}&ori=probation`);
    };

    const handleResign = (id) => {
        navigate(`/EmployeeResignationForm/${id}`);
    };

    const renderStaffListProbation = () => {
        const startIndex = (currentPage1 - 1) * pageSize;
        const endIndex = Math.min(startIndex + pageSize, employeeListsProbation.length);
    
        return employeeListsProbation
          .slice(startIndex, endIndex)
          .map(employee => (
            <tr key={employee.id} style={{ cursor: "pointer" }}>
                {isMobile ? (
                    <>
                        <td onClick={() => handleClickView(employee.id)} style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>
                            <div>
                                {employee.fullname
                                    .toLowerCase()
                                    .split(' ')
                                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                    .join(' ')}
                            </div>
                            <div style={{ fontSize: '12px', color: '#888', marginTop: '4px' }}>
                                Date Joined: {moment(employee.date_joined).format("YYYY-MM-DD")}
                            </div>
                        </td>
                        <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                <button className="Button Button-confirm" onClick={() => handleDropdownServiceLength(employee.fullname, employee.id, employee.employee_category.id, "J", "<5 YEARS", "A", "<2 YEARS")}>
                                    Confirm
                                </button>
                                <button className="Button Button-resign" onClick={() => handleResign(employee.id)}>
                                    Resign
                                </button>
                            </div>
                        </td>
                    </>
                ) : (
                    <>
                        {/* <td onClick={() => handleClickView(employee.id)}>{employee.fullname}</td> */}
                        <td onClick={() => handleClickView(employee.id)}>
                            {employee.fullname
                                .toLowerCase()
                                .split(' ')
                                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                .join(' ')}
                        </td>
                        {/* <td onClick={() => handleClickView(employee.id)}>{employee.username}</td> */}
                        <td onClick={() => handleClickView(employee.id)}>{employee.company.description}</td>
                        <td onClick={() => handleClickView(employee.id)}>{moment(employee.date_joined).format("YYYY-MM-DD")}</td>
                        {/* <td onClick={() => handleClickView(employee.id)}>{employee.service_length.description}</td> */}
                        <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        {/* <td style={{ overflow: "visible", position: "relative" }}> */}
                            {/* <Dropdown>
                                <Dropdown.Toggle 
                                    // className="Button" 
                                    style={{
                                        width: "100%",
                                        height: "28px", 
                                        backgroundColor: "white",
                                        color: "black", 
                                        fontSize: "13px",
                                        padding: "2px 8px",
                                        borderColor: "black"
                                    }}
                                >
                                    {getServiceLengthLabel(employee.service_length?.id).toUpperCase() || "UK"}
                                </Dropdown.Toggle>
                                <Dropdown.Menu style={{ width: "100%" }}>
                                {ServiceLength.map((action, index) => (
                                    <Dropdown.Item key={index} onClick={() => handleDropdownServiceLength(employee.fullname, employee.id, action.id, action.label)}>
                                    {action.label}
                                    </Dropdown.Item>
                                ))}
                                </Dropdown.Menu>
                            </Dropdown> */}
                            <button className="Button Button-confirm" onClick={() => handleDropdownServiceLength(employee.fullname, employee.id, employee.employee_category.id, "J", "<5 YEARS", "A", "<2 YEARS")}>
                                Confirm
                            </button>
                            <button className="Button Button-resign" onClick={() => handleResign(employee.id)}>
                                Resign
                            </button>
                        </td>
                    </>
                )}
            </tr>
          ));
    };

    // Function to get the ServiceLength type label
    const getServiceLengthLabel = (value) => {
        const length = ServiceLength.find(length => length.id === value);
        return length ? length.label : "";
    };
    
    const handleDropdownServiceLength = (fullname, employeeId, category, selectedLengthId, selectedLengthLabel, selectedLengthIdSLO, selectedLengthLabelSLO) => {
        
        const isSCategory = category === 'S';

        // Use different service length if category is 'S'
        const finalLengthId = isSCategory ? selectedLengthIdSLO : selectedLengthId;
        const finalLengthLabel = isSCategory ? selectedLengthLabelSLO : selectedLengthLabel;

        Swal.fire({
            text: `Confirm changing ${fullname}'s service length to "${finalLengthLabel}"?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                dispatch(dismissEmployee({ id: employeeId, service_length: { id: finalLengthId  } }))
                    .unwrap()
                    .then(() => {
                    setLoading(false);
                    Swal.fire({
                        text: fullname + ' service length is updated.',
                        icon: 'success',
                        confirmButtonText: 'OK'
                    }).then(() => {
                        // navigate(`/EmployeeList?searchText=${searchText}&active=${active}`);
                        window.location.reload();
                    });
                    })
                    .catch((err) => {
                    setLoading(false);
                    Swal.fire("Error", err.response.data, "error");
                    });
            }                        
        });
    };

    const handlePreviousPage1 = () => {
        setCurrentPage1(prevPage => Math.max(prevPage - 1, 1));
    };

    const handleNextPage1 = () => {
        setCurrentPage1(prevPage => Math.min(prevPage + 1, totalPages1));
    };

    const handlePageChange1 = (page) => {
        setCurrentPage1(page);
    };

    return (
        <div className="ContainerContent2">
        {loading && (
            <ThreeDots
            visible={loading}
            height="80"
            width="80"
            color="#4fa94d"
            radius="9"
            ariaLabel="three-dots-loading"
            wrapperStyle={{
                position: 'fixed',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: '9999',
            }}
            />
        )}
        <Card className="CardContent">
            <div className="d-flex justify-content-between">
                <ButtonGroup className="my-2">
                    <Button className="Button" onClick={() => navigate("/")}>
                    Back
                    </Button>
                </ButtonGroup>
            </div>
            <h1 className="TitleHeader">Employees Under Probation</h1>

            <InputGroup className="mb-3">
            <Form.Control placeholder="Search" value={searchText} onChange={handleSearch} onKeyPress={handleKeyPress} />
            <Button className="SearchIconBtn" onClick={() => handleBtnSearch(searchText, active)}>
                <FontAwesomeIcon icon={faSearch} />
            </Button>
            </InputGroup>

            {!loading && table && (
            <>
                <Pagination
                    currentPage={currentPage1}
                    totalPages={totalPages1}
                    handlePreviousPage={handlePreviousPage1}
                    handleNextPage={handleNextPage1}
                    handlePageChange={handlePageChange1}
                />

                <div style={{ overflowX: 'auto' }}>
                    <Table className="my-fixed-table" style={{ fontSize: "14px" }}>
                        <thead>
                            <tr>
                                {isMobile ? (
                                    <>
                                        <th>Staff</th>
                                        <th className="text-center align-middle">Action</th>
                                    </>
                                ) : (
                                    <>
                                        <th style={{ width: "30px" }}>Staff</th>
                                        {/* <th style={{ width: "10px" }}>Username</th> */}
                                        <th style={{ width: "30px" }}>Company</th>
                                        <th style={{ width: "10px" }}>Date Joined</th>
                                        <th style={{ width: "20px", textAlign: 'center', verticalAlign: 'middle' }}>Action</th>
                                    </>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {employeeListsProbation.length > 0 ? (
                                renderStaffListProbation()
                            ) : (
                                <tr>
                                    {/* <td colSpan="5">No results found</td> */}
                                    <td colSpan={isMobile ? "2" : "4"}>No results found</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>

                <Pagination
                    currentPage={currentPage1}
                    totalPages={totalPages1}
                    handlePreviousPage={handlePreviousPage1}
                    handleNextPage={handleNextPage1}
                    handlePageChange={handlePageChange1}
                />
            </>
            )}
            
            <div className="d-flex justify-content-between">
                <ButtonGroup>
                    <Button className="Button" onClick={() => navigate("/")}>
                    Back
                    </Button>
                </ButtonGroup>
                &nbsp; &nbsp;
            </div>
        </Card>
        </div>
    );
};

export default EmployeeProbationList;